import { render } from "./modalFlagging.vue?vue&type=template&id=bede9706"
import script from "./modalFlagging.vue?vue&type=script&lang=js"
export * from "./modalFlagging.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__